import { atom } from 'recoil';

const SupplierTypeAtom = atom({
  key: 'SupplierType',
  default: '',
});

export { SupplierTypeAtom };
